export class TimeField {
  constructor(
    public hour: number,
    public minute: number,
    public ampm: string
  ) {}
}
